export default {
  SHOW: "overlay/SHOW",
  HIDE: "overlay/HIDE"
};
